import { createSelector } from '@ngrx/store';

import { selectUsersState } from '../../../core.state';
import { getRouterInfo } from '../../../router/router.selector';
import { Utils } from '../../../utils/utils';

export const getUsers = createSelector(
    selectUsersState,
    (state) => state.usersList
);


export const selectUserId = createSelector(
    getRouterInfo,
    (routerInfo) => routerInfo.params.userId as string
);

export const getUsersLoaded = createSelector(
    selectUsersState,
    state => state.loaded
);

export const getUser = createSelector(
    selectUsersState,
    selectUserId,
    (state, userId) => {
        return state.usersList.find(b => b.id === userId);
    }
);

export const getUsersListFilterForm = createSelector(
    selectUsersState,
    (state) => state.userListFilterForm
);

export const selectUsersColumnState = createSelector(
    selectUsersState,
    state => state.gridColumnState
);

export const getFilteredUsers = createSelector(
    getUsers,
    getUsersListFilterForm,
    (users, usersListFilterForm) => {
        return users.filter(u =>
            (u.firstName.toUpperCase().indexOf(usersListFilterForm.value.name.toUpperCase()) >= 0
                || u.lastName.toUpperCase().indexOf(usersListFilterForm.value.name.toUpperCase()) >= 0)
            && u.email.toUpperCase().indexOf(usersListFilterForm.value.email.toUpperCase()) >= 0
            && u.fiscalCode.toUpperCase().indexOf(usersListFilterForm.value.fiscalCode.toUpperCase()) >= 0
        ).sort((u1, u2) => {
            let res = Utils.sort(u1.lastName, u2.lastName, true);
            if (res === 0){
                res = Utils.sort(u1.firstName, u2.firstName, true);
            }
            return res;
        });
    }
);

export const getDownloadedDocuemnts = createSelector(
    selectUsersState,
    state => state.downloadedDocuments
);
